import { AnalyticIdentifier } from '@common/neo.tax';
import { ReactElement } from 'react';

import { useDomainRedirect, useProvisionCurrentUser, useReportLoginFailure } from '@neo.tax/onboarding/hooks';
import {
  AuthType,
  LocalStorageKey,
  useAnalyticId,
  SsoProvider,
  startOAuth,
  AuthenticationState,
} from '@neo.tax/shared';

import { StyledMicrosoftIcon, StyledSsoButton } from './sso-buttons.styled';

export const MicrosoftOAuth = ({ authType }: { authType: AuthType }): ReactElement => {
  const microsoftOAuthBtnId = useAnalyticId(AnalyticIdentifier.RTC_MICROSOFT_OAUTH_BUTTON);
  const { getRedirectUrlForEmail } = useDomainRedirect();
  const provisionCurrentUser = useProvisionCurrentUser();
  const reportLoginFailure = useReportLoginFailure();

  const handleClick = async (): Promise<void> => {
    localStorage.setItem(LocalStorageKey.SESSION_MICROSOFT_AUTH_ATTEMPT, authType);
    await startOAuth({
      ssoProvider: SsoProvider.MICROSOFT,
      adapter: AuthenticationState.authenticationStateOAuthAdapter,
      enterpriseSsoProviderId: undefined,
      getSingleTenantRedirectUrl: getRedirectUrlForEmail,
      provisionCurrentUser,
      reportLoginFailure,
    });
  };

  return (
    <StyledSsoButton id={microsoftOAuthBtnId} onClick={handleClick} rounded="regular" size="base" variant="white">
      <StyledMicrosoftIcon /> Microsoft
    </StyledSsoButton>
  );
};
